import {$authHost, $host} from "./index";

export const createPlace = async (place) => {
    const {data} = await $authHost.post('api/places', place)
    return data
}
export const fetchAllPlaces = async () => {
    const {data} = await $host.get('api/places')
    return data
}

export const fetchPlaceMapSlopes = async (placeId, radius = 500, limit = 200, snapRadius = 900) => {
    const { data } = await $host.get(`api/places/${placeId}/map-slopes`, {
        params: {
            radius,
            limit,
            snapRadius
        }
    });

    return data;
};

export const fetchPlaceWalkingRoutes = async (placeId) => {
    const { data } = await $host.get(`api/places/${placeId}/walking-routes`);

    return data;
};

export const fetchPlaceMapEntries = async (id, radius = 120, limit = 100, category = '') => {
    const params = {
        radius,
        limit
    };

    if (category) {
        params.category = category;
    }

    const { data } = await $host.get(`/api/places/${id}/map-entries`, {
        params
    });

    return data;
};